
<template>
  <router-view />
</template>

<script>
export default {
  name: "app-emailLogs"
};
</script>

<style lang="scss" scoped></style>
